const popup = document.querySelector(".wcsatt-options-wrapper") as HTMLElement;
const popupSubContent = document.querySelector(".wcsatt-options-product-wrapper") as HTMLElement;
const popupSelect = document.querySelector(".wcsatt-options-product-dropdown") as HTMLSelectElement;

if (popup && popupSubContent && popupSelect) {

    //Insert One-Time text
    let popupSinglecontent =  document.createElement("div");
    const popupText = (window as any).njamito_ajax.translation.popupText;

    popupSinglecontent.classList.add("wcsatt-options-product-wrapper")
    popupSinglecontent.classList.add("wcsatt-options-product-wrapper--single")
    popupSinglecontent.textContent = popupText
    
    popupSubContent.after(popupSinglecontent)

    //Insert Subscribe text

    let popupListContent =  document.createElement("div");
    const popupList = (window as any).njamito_ajax.translation.popupList;

    popupListContent.innerHTML = popupList
    
    popupSelect.after(popupListContent)

}